export default "__VITE_ASSET__CVhLc3W7__"